// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var whenJust = function (dictApplicative) {
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just) {
                return v1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(dictApplicative)(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Control.Applicative.Extra (line 10, column 1 - line 10, column 76): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var for2 = function (dictApply) {
    return function (x) {
        return function (y) {
            return function (f) {
                return Control_Apply.apply(dictApply)(Data_Functor.map(dictApply.Functor0())(f)(x))(y);
            };
        };
    };
};
export {
    whenJust,
    for2
};
//# sourceMappingURL=index.js.map
